import { configureAppStore } from "./configureStore"

// preloadedState will be passed in by the plugin
// eslint-disable-next-line no-unused-vars
export default () => configureAppStore()
